export const OPEN_DROPDOWN = "OPEN_DROPDOWN";
export const OPEN_COMPLETE = "OPEN_COMPLETE";
export const CLOSE_DROPDOWN = "CLOSE_DROPDOWN";
export const MY_ACCOUNT = "myAccount";
export const MINIBAG = "miniBag";
export const DROPDOWN_NAMES = [MY_ACCOUNT, MINIBAG];
export const DROPDOWN_CLOSED = "DROPDOWN_CLOSED";
